import api from './api';
import {
  VoiceResponse,
  CharacterVoiceRequest,
  CharacterVoiceResponse,
  VoiceSuggestionResponse,
  ScriptAudioRequest,
  AudioPinCreate,
  AudioPinUpdate,
  AudioPinResponse,
} from '../types';

export const voicesService = {
  async getVoices(): Promise<VoiceResponse[]> {
    const response = await api.get<VoiceResponse[]>('/voices/voices');
    return response.data;
  },

  async getProjectCharacters(projectId: number): Promise<{ characters: any[] }> {
    const response = await api.get<{ characters: any[] }>(`/voices/projects/${projectId}/characters`);
    return response.data;
  },

  async getCharacterVoices(projectId: number): Promise<CharacterVoiceResponse[]> {
    const response = await api.get<CharacterVoiceResponse[]>(`/voices/projects/${projectId}/character-voices`);
    return response.data;
  },

  async setCharacterVoice(projectId: number, request: CharacterVoiceRequest): Promise<CharacterVoiceResponse> {
    const response = await api.post<CharacterVoiceResponse>(
      `/voices/projects/${projectId}/character-voices`,
      request
    );
    return response.data;
  },

  async suggestVoices(projectId: number): Promise<VoiceSuggestionResponse[]> {
    const response = await api.post<VoiceSuggestionResponse[]>(`/voices/projects/${projectId}/suggest-voices`);
    return response.data;
  },

  async synthesizeAudio(projectId: number, request: ScriptAudioRequest): Promise<Blob> {
    const response = await api.post(
      `/voices/projects/${projectId}/synthesize-audio`,
      request,
      { responseType: 'blob' }
    );
    return response.data;
  },

  async createAudioPin(projectId: number, request: AudioPinCreate): Promise<AudioPinResponse> {
    const response = await api.post<AudioPinResponse>(
      `/voices/projects/${projectId}/audio-pins`,
      request
    );
    return response.data;
  },

  async getAudioPins(projectId: number): Promise<AudioPinResponse[]> {
    const response = await api.get<AudioPinResponse[]>(`/voices/projects/${projectId}/audio-pins`);
    return response.data;
  },

  async updateAudioPin(projectId: number, pinId: number, request: AudioPinUpdate): Promise<AudioPinResponse> {
    const response = await api.patch<AudioPinResponse>(
      `/voices/projects/${projectId}/audio-pins/${pinId}`,
      request
    );
    return response.data;
  },

  async deleteAudioPin(projectId: number, pinId: number): Promise<void> {
    await api.delete(`/voices/projects/${projectId}/audio-pins/${pinId}`);
  },
};

